import { registerLegacySalvoLiteComponent, log } from '@eastsideco/salvo-ts';
import axios from 'axios';

class ShowMore {
    constructor(theme, elem) {
        this._theme = theme;
        this._name = this.constructor.name;
        this._elem = elem;
        this._text = elem.getAttribute('data-text');
        this._loadingText = elem.getAttribute('data-loading-text');
        this._itemContainerSelector = elem.getAttribute('data-item-container-selector');
        this._itemSelector = elem.getAttribute('data-item-selector');
        this._paginationWrapper = elem;
    }

    onInit() {
        // Update text content
        this._elem.innerHTML = this._text;

        // Listen for clciks
        this._elem.addEventListener('click', () => {

            // Set loading text
            this._elem.innerHTML = this._loadingText;

            // Get scroll-y value
            let scroll = parseInt(window.scrollY, 10);

            // Load more
            this.loadMore(scroll);
        });
    }

    loadMore(scroll) {

        // Prepare variables
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const nextUrl = this._elem.getAttribute('data-next-page');

        // Make request for the next page
        axios.get(nextUrl).then((response) => {

            // Get new elements from response data and add them to a new elements wrapper
            const newElementsWrapper = document.createElement('div');
            newElementsWrapper.innerHTML = response.data;

            // Update pagination results
            const newResults = newElementsWrapper.querySelector('.pagination__results');
            self.updatePaginationResults(newResults);

            // Update next page url
            const newMoreButton = newElementsWrapper.querySelector('[data-show-more]');
            self.updateNextPageUrl(newMoreButton);

            // Add new elements to page
            // eslint-disable-next-line no-underscore-dangle
            const newElements = newElementsWrapper.querySelectorAll(self._itemSelector);
            self.addNewElements(newElements, nextUrl, scroll);
        }).catch((e) => {
            log.error('Pagination', `Error requesting next page`, { e });
        });
    }

    updatePaginationResults(newResults) {
        const oldResults = document.querySelector('.pagination__results');
        if (newResults && oldResults) {
            oldResults.parentNode.replaceChild(newResults, oldResults);
        }
    }

    updateNextPageUrl(nextButton) {

        // Check that the button exists
        if (nextButton) {

            // Update pagination URL attribute
            const newNextPage = nextButton.getAttribute('data-next-page');
            const oldMoreButton = document.querySelector('[data-show-more]');
            oldMoreButton.setAttribute('data-next-page', newNextPage);

        // Button doesn't exist, no more items to load
        } else {

            // Remove pagination
            this._paginationWrapper.remove();
        }
    }

    addNewElements(els, url, scroll) {

        // Loop through each new element
        for (const el of els) {

            // Check for preload attributes - update image src's
            if (el.querySelector('[data-preload]')) {
                let preloads = el.querySelectorAll('[data-preload]');
                for (const p of preloads) {
                    p.setAttribute('src', p.getAttribute('data-preload'));
                    p.removeAttribute('data-preload');
                }
            }

            // Add new element to the DOM
            document.querySelector(this._itemContainerSelector).appendChild(el);

            // Update button text
            this._elem.innerHTML = this._text;
        }

        // Scroll to correct position
        window.scrollTo(0, scroll);
    }
}

export default registerLegacySalvoLiteComponent({
    component: ShowMore,
    selector: '[data-show-more]', // Required
});
